import React from 'react';
import PropTypes from 'prop-types';
import { Widget } from './index';
//Test1
/**
 * Factory component that renders different widgets based on their type
 */
const WidgetRenderer = ({ questionGroup, page, validationErrors }) => {
  const widgetType = questionGroup.type;
  const widgetDefinition = Widget.widgetList[widgetType];
  
  if (!widgetDefinition) {
    console.warn(`Widget type "${widgetType}" not found`);
    return (
      <div className="widget-error">
        Widget type &ldquo;{widgetType}&rdquo; not found
      </div>
    );
  }

  // Extract widget options from questionGroup attributes
  const widgetOptions = questionGroup.attributes?.options || {};
  
  // Get widget dimensions for reference if needed within widgets
  const width = questionGroup.attributes?.width || widgetDefinition.gridSettings.defaultWidth;
  const height = questionGroup.attributes?.height || widgetDefinition.gridSettings.defaultHeight;
  
  // Create guide data object for template transformation
  const guideData = {
    answers: page.answers || {},
    page: page.page || {},
    path: page.path || {},
    questionGroup: questionGroup
  };
  
  // Transform placeholders in options
  const transformedOptions = Widget.transformValuesInObject(guideData, widgetOptions);
  
  // Prepare props for the widget
  const widgetProps = {
    width,
    height,
    questionGroup,
    page,
    validationErrors,
    className: `widget widget--${widgetType.toLowerCase()}`
    // No longer need gridColumn and gridRow styles as they're handled by Ant Design Col component
  };
  
  // Call the render function from the widget definition
  return widgetDefinition.render(guideData, transformedOptions, widgetProps);
};

WidgetRenderer.propTypes = {
  questionGroup: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  validationErrors: PropTypes.array
};

export default WidgetRenderer;